// src/components/Layout/Navbar.js
import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FiMenu } from 'react-icons/fi'; // Using Feather icons
import ProfileDropdown from './ProfileDropdown';
import logoSrc from '../../NFC Assets/Logo/Black  NFC Horizontal Logo.png'; // Make sure you have this

import profileSrc from '../../NFC Assets/Logo/Black  NFC Logo.png'; // And this
import "./All.css"

const Nav = styled.nav`
  background-color: ${({ theme }) => theme.colors.surface};
  height: ${({ theme }) => theme.navbarHeight};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing.lg};
  box-shadow: ${({ theme }) => theme.shadows.sm}; // Softer shadow
  position: sticky;
  top: 0;
  z-index: 1000; // Above sidebar overlay
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightBorder};
`;

const NavLeft = styled.div`
  display: flex;
  align-items: center;
`;

const HamburgerButton = styled.button`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.5rem;
  margin-right: ${({ theme }) => theme.spacing.md};
  padding: ${({ theme }) => theme.spacing.xs};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  transition: ${({ theme }) => theme.transitions.short};
  display: flex; // For FiMenu alignment
  align-items: center;
  justify-content: center;
  
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.primary}1A;
  }

  /* Always show on mobile, hide on larger screens where sidebar is open by default */
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    /* Hide if sidebar is meant to be static/always open on desktop */
    /* display: none; // Uncomment if sidebar is fixed open on desktop and no toggle needed */
  }
`;

const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  height: 32px;
  margin-right: ${({ theme }) => theme.spacing.sm};
`;

const LogoText = styled.span`
  font-size: 1.5rem; /* 24px */
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.primary}; /* Use primary color for logo */
  letter-spacing: -0.5px;
`;


const NavRight = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const ProfileImageButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  border-radius: ${({theme}) => theme.borderRadius.round};
  overflow: hidden; /* Ensures border-radius clips image */
  cursor: pointer;
  
  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.primaryLight};
    outline-offset: 2px;
  }
`;

const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: ${({theme}) => theme.borderRadius.round};
  transition: ${({ theme }) => theme.transitions.short};
  border: 2px solid transparent;

  ${ProfileImageButton}:hover & {
    transform: scale(1.08);
    border-color: ${({ theme }) => theme.colors.primaryLight}80;
  }
`;


const Navbar = ({ toggleSidebar }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const profileRef = useRef(null);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const user = { name: "Elena Petrova", email: "elena.p@example.com" };

  return (
    <Nav>
      <NavLeft>
        <HamburgerButton onClick={toggleSidebar} aria-label="Toggle Sidebar">
          <FiMenu />
        </HamburgerButton>
        <LogoLink to="/">
       <div >
        <img  src={logoSrc} 
  alt="Dashboard Logo" 
  className="navlogokanak"  />
 
</div>

      
        </LogoLink>
      </NavLeft>
      <NavRight ref={profileRef}>
        <ProfileImageButton onClick={toggleDropdown} aria-label="User menu" aria-expanded={dropdownOpen}>
          <ProfileImage src={profileSrc} alt="User Profile" />
        </ProfileImageButton>
        <ProfileDropdown isOpen={dropdownOpen} user={user} onLogout={() => setDropdownOpen(false)} />
      </NavRight>
    </Nav>
  );
};

export default Navbar;